import { Routes } from '@angular/router';
import { sessionGuard } from './guards/session.guard';

export const routes: Routes = [
  {
    path: 'mandates',
    loadComponent: () => import('./pages/entry/entry.component').then(m => m.EntryComponent),
  },
  {
    path: 'details',
    loadComponent: () => import('./pages/request-details/request-details.component').then(m => m.RequestDetailsComponent),
    canActivate: [sessionGuard],
  },
  {
    path: 'terms',
    loadComponent: () => import('./pages/request-terms/request-terms.component').then(m => m.RequestTermsComponent),
    canActivate: [sessionGuard],
  },
  {
    path: 'additional-properties',
    loadComponent: () => import('./pages/additional-properties/additional-properties.component').then(m => m.AdditionalPropertiesComponent),
    canActivate: [sessionGuard],
  },
  {
    path: 'signing',
    loadComponent: () => import('./pages/signing/signing.component').then(m => m.SigningComponent),
    canActivate: [sessionGuard],
  },
  {
    path: 'success',
    loadComponent: () => import('./pages/result/success.component').then(m => m.SuccessComponent),
  },
  {
    path: 'error',
    loadComponent: () => import('./pages/result/error.component').then(m => m.ErrorComponent),
  },
  {
    path: 'expired',
    loadComponent: () => import('./pages/result/expired.component').then(m => m.ExpiredComponent),
  },
  {
    path: 'rejected',
    loadComponent: () => import('./pages/result/rejected.component').then(m => m.RejectedComponent),
  },
  {
    path: '**',
    redirectTo: '/error',
  },
];
